const colors = {
  primary: "#CC3333",
  secondary: "#663366",
  third: "#41AA34",
  lighterGray: "#E6E6E6",
  lightGray: "#9D9D9D",
  gray: "#585858",
  white: "#FFFFFF",
  facebook: "#1877F2",
  mail: "#50b2a4",
  black: "#000000",
  stepper: "#F5F5F5",
  success: "#41AA34",
  text: "#333333",
  background: "#FAFAFA",
  transparent: "transparent",
  header: "#fdfdfd",
  pageBackground: "#F7F7F7",
  warning: "#F59E0B",
  error: "#E53E3E",
};

module.exports = colors;
